import axios from 'axios';

/**
 * Fetches a short-lived presigned download URL for the marketing materials
 * matching the merchant type. The URL carries Content-Disposition:
 * attachment, so navigating to it triggers a save with the right filename.
 * @param merchantType - The merchant type (e.g., 'COFFEE_SHOP')
 */
export const getMarketingMaterialDownload = async (
  merchantType: string
): Promise<{ url: string; filename: string }> => {
  const { data } = await axios.get(
    `${import.meta.env.REACT_APP_API_URL}merchant/marketing-material`,
    { params: { merchantType } }
  );
  return data;
};
